/**
 * Browser Supabase client.
 *
 * Uses the anon key only. RLS in Postgres does all access control.
 * NEVER add the service role key here — it would be inlined into the
 * client bundle by Vite at build time.
 *
 * For edge-only access (Pages Functions), see `./server.ts`.
 */

import { createClient } from '@supabase/supabase-js';
import type { Database } from './types.gen';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

if (import.meta.env.DEV && (!url || !anonKey)) {
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local. ' +
      'Reads will fail until these are set.',
  );
}

if (import.meta.env.PROD && /^https?:\/\/(127\.0\.0\.1|localhost)(?::|\/|$)/.test(url)) {
  throw new Error(
    '[supabase] Production build is configured with a local Supabase URL. ' +
      'Set VITE_SUPABASE_URL to the remote project URL before building.',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  db: {
    schema: 'public',
  },
});
